import React from "react";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import Input from "./Input";

import "react-datepicker/dist/react-datepicker.css";

const StyledReactDatePicker = Input.withComponent(ReactDatePicker);

const DatePicker = ({ value, utc, onBlur, ...otherProps }) => {
  const selected = moment(value);
  if (utc) selected.utc();

  // Override blur handler to pass a moment back to redux-form
  const handleBlur = e => {
    if (typeof onBlur === "function") {
      const { value } = e.target;
      const momentValue = moment(value);
      onBlur(momentValue);
    }
  };

  return (
    <StyledReactDatePicker
      {...otherProps}
      onBlur={handleBlur}
      selected={selected}
    />
  );
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/forms/DatePicker.js